import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/company";
import { fileUrl } from "@/lib/api";

export default function Footer() {
  const services = [
    ["Maçonnerie générale", "/services/maconnerie-generale"],
    ["Rénovation & réhabilitation", "/services/renovation-rehabilitation"],
    ["Béton & ouvrages structurels", "/services/beton-ouvrages-structurels"],
    ["Murs & clôtures", "/services/murs-clotures"],
    ["VRD & aménagements extérieurs", "/services/vrd-reseaux"],
    ["Finitions & reprises", "/services/finitions-reprises"],
  ];
  return (
    <footer className="bg-ink text-white/90" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 border-b border-white/10">
        <div>
          <img src={fileUrl(COMPANY.logo)} alt="SMT Provence" className="h-14 w-auto mb-4" />
          <p className="text-sm text-white/60 leading-relaxed">{COMPANY.tagline}. Au service des particuliers, professionnels, collectivités et structures publiques en Provence.</p>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white mb-4 text-lg">Nos services</h4>
          <ul className="space-y-2 text-sm">
            {services.map(([label, to]) => (
              <li key={to}><Link to={to} className="text-white/60 hover:text-primary transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white mb-4 text-lg">Navigation</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/realisations" className="text-white/60 hover:text-primary">Réalisations</Link></li>
            <li><Link to="/conseils" className="text-white/60 hover:text-primary">Conseils & articles</Link></li>
            <li><Link to="/faq" className="text-white/60 hover:text-primary">FAQ</Link></li>
            <li><Link to="/contact" className="text-white/60 hover:text-primary">Demande de devis</Link></li>
            <li><Link to="/admin/login" className="text-white/40 hover:text-primary">Espace pro</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-bold text-white mb-4 text-lg">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3"><Phone size={17} className="text-primary mt-0.5" /><a href={`tel:${COMPANY.phoneHref}`}>{COMPANY.phone}</a></li>
            <li className="flex items-start gap-3"><Mail size={17} className="text-primary mt-0.5" /><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
            <li className="flex items-start gap-3"><MapPin size={17} className="text-primary mt-0.5" /><span>{COMPANY.address}</span></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} SMT Provence — SIRET {COMPANY.siret} — APE {COMPANY.ape} — TVA {COMPANY.tva}</p>
        <div className="flex items-center gap-4">
          <Link to="/mentions-legales" className="hover:text-primary transition-colors">Mentions légales</Link>
          <Link to="/confidentialite" className="hover:text-primary transition-colors">Confidentialité</Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-3">
          <p className="text-[11px] text-white/30 order-2 sm:order-1" data-testid="footer-version">
            Dernière mise à jour : {COMPANY.lastUpdate} · Version {COMPANY.version}
          </p>
          <a href="https://besson-solutions.fr" target="_blank" rel="noopener noreferrer"
             data-testid="footer-credit"
             className="inline-flex items-center gap-2 text-[11px] text-white/35 hover:text-white/70 transition-colors order-1 sm:order-2">
            <img src={fileUrl(COMPANY.bessonLogoWhite)} alt="Besson Solutions" className="h-6 w-auto object-contain" />
            Site &amp; application réalisés par <span className="font-semibold text-white/60">Besson-solutions.fr</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
